/*eslint-disable*/ 
import React, {useState, useEffect, memo } from "react";

import { useParams } from "react-router";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery }  from "react-responsive";

// core components
import HeaderNavbar from "components/Navbar/HeaderNavbar";
import FooterNavbar from "components/Navbar/FooterNavbar";
import AdNormal from "components/AdSense/AdNormal.jsx";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Loading from "components/Loading/Loading";
// sections for this page
import SectionText from "./Sections/SectionText.jsx";
//import SectionComments from "./Sections/SectionComments.jsx";
import SectionImages from "./Sections/SectionImages.jsx";

import blogPostPageStyle from "assets/jss/trip-kit/views/blogPostPageStyle.js";

const useStyles = makeStyles(blogPostPageStyle);

const ContentsPost = memo((props) => {
  const [detailCommon, setDetailCommon] = useState(null);
  const [detailImages, setDetailImages] = useState([]);
  const [detailIntro, setDetailIntro] = useState([]);
  const [detailInfos, setDetailInfos] = useState([]);
  const [recommendTravelList, setRecommendTravelList] = useState([]);
  const [recommendFoodList, setRecommendFoodList] = useState([]);
  const [recommendHotelList, setRecommendHotelList] = useState([]);
  const [loading, setLoading] = useState(null);
  const [fixYn, setFixYn] = useState(false);
  const classes = useStyles();
  let { id } = useParams();
  let { type } = useParams();

  const isMobile = useMediaQuery({
    query : "(max-width: 767px)"
  })
  const isPc = useMediaQuery({
    query : "(min-width: 1460px)"
  })
if(isPc){
  document.addEventListener('scroll', () => {
    let nowScrollTop = document.documentElement.scrollTop;
    if(nowScrollTop >300){
      setFixYn(true);
    } else {
      setFixYn(false);
    }
  });
}

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    /**공통정보 조회 */
    setLoading(true);
    props.visitkorea
    .detailCommon(id)
    .then(function (response) {
      setLoading(false);
      setDetailCommon(response);

      /**지역기반 조회(recommend travel) */
      props.visitkorea
      .areaBased(props.lang, "1", "3", "1",response.areacode,response.sigungucode)
      .then(function (response) {
        setRecommendTravelList(response.items.item);
      });
      /**지역기반 조회(recommend food) */
      props.visitkorea
      .areaBased(props.lang, "3", "3", "1",response.areacode,response.sigungucode)
      .then(function (response) {
        setRecommendFoodList(response.items.item);
      });
      /**지역기반 조회(recommend hotel) */
      props.visitkorea
      .areaBased(props.lang, "4", "3", "1",response.areacode,response.sigungucode)
      .then(function (response) {
        setRecommendHotelList(response.items.item);
      });
    })
    .catch(function(error) {
      alert("You requested the wrong data.");
      window.location.href="/";
    });

    /**추가이미지정보 조회 */
    props.visitkorea
    .detailImages(id,"Y")
    .then(function (response) {
      setDetailImages(response);
      if(props.type =="food"){ //Y=콘텐츠 이미지 조회, N=”음식점”타입의 음식메뉴 이미지
        props.visitkorea
        .detailImages(id,"N")
        .then(function (response2) {
          response && response2 ? setDetailImages(response.concat(response2))
          : response ? setDetailImages(response) : response2 ? setDetailImages(response2) :""
        }); 
      }
    }); 

    /**소개정보 조회 */
    props.visitkorea
    .detailIntro(id,type)
    .then(function (response) {
      setDetailIntro(response);
    });

    /**반복정보 조회 */
    props.visitkorea
    .detailInfo(id,type)
    .then(function (response) {
      setDetailInfos(response);
    });
    
  },[props.visitkorea,props.lang, props.type, id, type]);

  return (
    <div>
    <HeaderNavbar {...props}/>
    {
      detailCommon &&
      <>
      <Parallax image={detailCommon.firstimage ==undefined ? "" :  detailCommon.firstimage.replace('http:', 'https:')} filter="dark" smallB>
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
            {
              isMobile ?
              <h3 className={classes.title}>{detailCommon.title}</h3>
              :
              <h2 className={classes.title} style={{fontSize:"30px"}}>{detailCommon.title}</h2>
            }
          </GridItem>
        </GridContainer>
      </div>
    </Parallax>
    <div className={classes.main}>
      <div className={classes.container} style={{minHeight:"500px"}}>
      {
        loading ? <div style={{textAlign:"center",padding:"40px"}}><Loading /></div> 
        : <>
        <SectionImages {...props} detailImages={detailImages} />
        <SectionText currentPath={props.location.pathname} detailCommon={detailCommon} detailIntro={detailIntro} detailInfos={detailInfos} contentType={props.type} recommendTravelList={recommendTravelList} recommendFoodList={recommendFoodList} recommendHotelList={recommendHotelList} lang={props.lang}/>
        {/*<SectionComments />*/}
        </>
      }
    
      </div>
      {
        isPc &&
        <GridContainer id="test" style={ fixYn ? {position:'fixed', top:"170px", left:"30px",width:"330px"} : {position:'absolute', top:"70px", left:"0",width:"330px"} }>
        <GridItem >
          <AdNormal currentPath={props.location.pathname} slot="8002520350"/>
        </GridItem>
        </GridContainer>
      }
     
    </div>
    </>
    }

      <FooterNavbar />
    </div>
  );
});
export default ContentsPost;